module.exports = __webpack_public_path__ + "img/1 (83).3a2a1e47.png";